import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';
import { CircularProgress } from '@mui/material';
import RascunhoCertidao from '@/components/certidao/RascunhoCertidao';
import { computed, makeObservable } from 'mobx';

class RascunhoCertidaoComCarregamento extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    render() {
        return (
            <div
                id={'rascunho'}
                style={{ display: 'flex', flexDirection: 'column' }}
            >
                {this.observableProps.registro && this.observableProps.registro.decisao !== undefined ? (
                    <RascunhoCertidao
                        registro={this.observableProps.registro}
                        alturaRascunho={this.observableProps.alturaRascunho}
                    />
                ) : (
                    <div style={{ margin: '20px' }}>
                        <CircularProgress />
                    </div>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(RascunhoCertidaoComCarregamento));
